import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/authSlice'
import brandsReducer from './slices/brandsSlice'
import mocksReducer from './slices/mocksSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    brands: brandsReducer,
    mocks: mocksReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

